// You know where to get new material palette, right?: https://www.materialpalette.com/
export default {
  primaryColorDark: '#23262A',
  primaryColor: '#23262A',
  primaryColorLight: '#B2DFDB',
  primaryColorText: '#F7F7F7',
  accentColor: '#86da24',
  primaryTextColor: '#212121',
  secondaryTextColor: '#757575',
  dividerColor: '#BDBDBD',
  headFontFamily: 'Caviardreams',
  handFontFamily: 'VAG',
  bodyFontFamily: 'BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
}



// WEBPACK FOOTER //
// ./src/style/theme.jsx